import { ArrowUpRight } from "lucide-react";
import { services } from "@/constants/content";
import { BUYER_FORM_URL } from "@/constants/links";
import { MaskedLine, FadeIn } from "@/components/Reveal";

export default function Services() {
  return (
    <>
      <section data-testid="services-page" className="relative overflow-hidden pb-14 pt-32 sm:pt-40 lg:pt-48">
        <div className="pointer-events-none absolute -top-24 right-[-8%] h-[26rem] w-[26rem] rounded-full bg-[#1E3A8A]/10 blur-[110px]" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
          <p className="eyebrow" data-testid="services-eyebrow">What We Offer</p>
          <h1 className="mt-8 font-sans text-4xl font-bold leading-[1.08] tracking-tight text-[#0F172A] sm:text-5xl lg:text-6xl">
            <MaskedLine delay={0.15}>Our Services</MaskedLine>
          </h1>
        </div>
      </section>

      <section data-testid="services-list" className="mx-auto max-w-7xl px-4 pb-20 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:gap-8">
          {services.map((s, i) => (
            <FadeIn key={s.name} delay={0.07 * i}>
              <div data-testid={`service-page-card-${i + 1}`} className="card-dark group h-full p-8 sm:p-10 hover:-translate-y-1">
                <span className="font-sans text-sm tracking-[0.25em] text-[#1E3A8A]/50">0{i + 1}</span>
                <h2 className="mt-5 font-sans text-xl text-[#0F172A] transition-colors duration-500 group-hover:text-[#1D4ED8] sm:text-2xl">{s.name}</h2>
                <p className="mt-3 text-sm leading-relaxed text-[#64748B] sm:text-base">{s.copy}</p>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn delay={0.2}>
          <a href={BUYER_FORM_URL} target="_blank" rel="noopener noreferrer" data-testid="services-cta" className="btn-gold mt-12">
            Join the Buyer Waitlist <ArrowUpRight size={16} />
          </a>
        </FadeIn>
      </section>
    </>
  );
}
